module.exports = __webpack_public_path__ + "public/images/value-description-video-section-bg.26a9e3299c7afba0c2aad8dd5e5fa597.svg";